import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { APP_CONST } from "../config/const";
import { balanceUpdate, logoutUser } from "../redux/auth/actions";
import { socketFunc } from "../utils/socketUtil";
import { Toaster } from "../utils/toaster";

function SocketProvider({ children }) {
  const token = useSelector((state) => state.auth?.token);
  const dispatch = useDispatch();

  useEffect(() => {
    const socket = socketFunc(token);

    if (token) {
      socket.on("sub:notification_toast", (res) => {
        if (res) {
          let errorMessage =
            res?.title && res?.message
              ? `${res?.title} : ${res?.message}`
              : !res?.title
              ? res.message
              : res.title;

          Toaster(
            Object.values(APP_CONST.TOAST_TYPE).find(
              (f) => f === res?.status
            ) || APP_CONST.TOAST_TYPE.ERROR,
            errorMessage || "Something went wrong"
          );
        }
      });

      socket.emit("session_check", (data) => {
        if (data?.status === "failed") {
          dispatch(logoutUser());
          // window.location.href = "/";
        }
      });

      socket.on("session_refresh", () => {
        // console.log();
        socket.emit("session_check", (data) => {
          if (data?.status === "failed") {
            dispatch(logoutUser());
            // window.location.href = "/";
          }
        });
      });

      socket.on("connect_error", async (error) => {
        if (error?.data?.type === "SessionError") {
          Toaster(APP_CONST.TOAST_TYPE.ERROR, error?.data?.message);
          dispatch(logoutUser());

          return;
        }

        socket.io.opts.transports = ["polling", "websocket"];
      });

      socket.emit("get:balance", (data) => {
        if (data?.status === "success") {
          dispatch(balanceUpdate(data));
        }
      });

      socket.on("update_balance", (data) => {
        if (!isNaN(parseFloat(data.balance))) {
          dispatch(balanceUpdate(data));
        } else {
          socket.emit("get:balance", (data) => {
            if (data?.status === "success") {
              dispatch(balanceUpdate(data));
            }
          });
        }
      });
    }
    // return () => {};

    return () => {
      socket.off("session_refresh");
      socket.off("update_balance");
      socket.off("sub:notification_toast");
    };
  }, [token, dispatch]);

  return <>{children}</>;
}

export default SocketProvider;
